import React from 'react';

import SimpleContainer from '../../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../../containers/categorycontainer/CategoryContainer';
import QuotesList from '../../components/quotes-list/quotes-list';

import backgroundImage from '../../media/help-and-guides/there-is-hope.jpg';

import 'bootstrap/dist/css/bootstrap.css';

import { PageText, Categories } from '../../input-text/en/help-and-guides/there-is-hope_page';

class ThereIsHope extends React.Component {

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container' backgroundImage={backgroundImage}>
          <div className='col-sm-offset-4 col-sm-8 header-info'>
            <h1>{PageText._1}</h1>
            <p>{PageText._2}</p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='1' category={ Categories._1 } component={ <QuotesList quotes={Categories._1.quotes} /> } />
      </div>
    );
  }
};

export default ThereIsHope;



// WEBPACK FOOTER //
// ./src/routes/help-and-guides/ThereIsHope.js